module.exports = __webpack_public_path__ + "static/media/sony.031b9cba.png";